((FreeGift, $) => {
  'use strict';

  const addGiftToCart = () => {
    // get selected variant ID
    const variantSelector = document.querySelector('[data-free-gift-selector]')
    const selectedVariant = Number(variantSelector.value);

    // build data object
    const data = {
      quantity: 1,
      id: selectedVariant
    };

    // remove select listener
    removeSelectListener();

    // add to the cart with line-item prop
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then(response => {
        InlineCart.miniCartLoad(false, true);
    }).catch(err => console.log(err));
  }

  const updateVariantImage = event => {
    const image = document.querySelector('img[data-gift-image]');
    const newSrc = event.target.querySelector('option:checked').dataset.imgSrc;

    if(newSrc === image.src) return;

    if(newSrc) {
      image.src = newSrc;
    }
  }

  const bindSelectListener = () => {
    const selector = document.querySelector('select[data-free-gift-selector]');
    if(selector) {
      selector.addEventListener('change', updateVariantImage);
    }
  }

  const removeSelectListener = () => {
    const selector = document.querySelector('select[data-free-gift-selector]');
    if(selector) {
      selector.removeEventListener('change', updateVariantImage);
    }
  }

  const bindUIActions = () => {
    document.addEventListener('click', event => {
      const el = event.target;
      if(el.matches('[data-add-free-gift]')) {
        addGiftToCart();
      }
    });

  };

  const init = () => {
    bindUIActions();
  };

  FreeGift.init = init;
  FreeGift.bindSelectListener = bindSelectListener;
  FreeGift.removeSelectListener = removeSelectListener;

})(window.FreeGift = window.FreeGift || {}, jQuery);
